import { ConfigurationService } from '@oel/js-configuration';

export type AppParams = {
    staticSpaUrl: string;
};

const getOelStaticSpaUrlFromMeta = (): string => {
    const oelStaticSpaUrl: string =
        ConfigurationService.getConfig('oel-static-spa-url');
    return oelStaticSpaUrl ? oelStaticSpaUrl : '.';
};

export const appParams: AppParams = {
    staticSpaUrl: getOelStaticSpaUrlFromMeta()
};
